export default __webpack_public_path__ + "CircularCustCapNum-LightItalic.c372727d7ecb3bc90021b401cf137273.woff2";